import angular from 'angular';
import { metricEventItemComponent } from './metricEventItemComponent';

angular.module('sh.metricEventItem', ['sh.api']).component('shMetricEventItem', metricEventItemComponent());
